import React from "react";
import "../../styles/Offerings/Offering.css";
import "../../styles/Offerings/OfferingBanner.css";

const OfferringBanner = () => {
  return (
    <div className="offering-banner-container">
      <div className="offering-banner-innercontainer">
        <div>
          <div className="offering-banner-title">Find the Right Plan For Your Startup</div>
          <div className="offering-banner-desc">Turn Your Startup Dream Into Reality In 2025!</div>
        </div>
        <div>
          <img className="offering-img" src="/offerings.svg" alt="offering-icon" />
        </div>
      </div>
    </div>
  );
};

export default OfferringBanner;
